import { useState, useEffect, useMemo } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import {
  LayoutGrid, Users, Inbox, ClipboardList, Receipt,
  SlidersHorizontal, ShieldCheck, Truck, FileText, CalendarX, Wallet, Stethoscope, FileCheck2, FileCog, BarChart3, Settings, TrendingUp,
  Clock, CalendarClock, FilePlus, List, Search, FileSpreadsheet, Trash2, CreditCard, AlertTriangle, UserCog, Contact,
  Undo2, PlusCircle, MinusCircle, CheckCircle2, Wrench, Tags, Landmark, Percent, MapPin,
  FileInput, Handshake, BarChart2, Coins, Upload, Fuel, RefreshCw, Car, HeartPulse, Award, IdCard, Cake, Plane, BellRing, CalendarDays,
  ChevronDown, ChevronLeft, ChevronRight, LogOut, Building2, Download, PlugZap, Gauge, History,
  type LucideIcon,
} from 'lucide-react'
import { useEmpresa } from '../contexts/EmpresaContext'
import { saidaBloqueada } from '../utils/guardaSaida'
import LogoFrotaWeb from './LogoFrotaWeb'

interface Props {
  user: string
  onLogout: () => void
  acessoLimitado: boolean
  apenasVendas: boolean
  /* Telas liberadas na aba Opções do Cadastro de Usuários; null = usuário sem configuração (vale o tiplib) */
  telasPermitidas: Set<string> | null
  children: React.ReactNode
}

const pageTitles: Record<string, string> = {
  '/': 'Principal',
  '/nfe/emitir': 'Emitir NF-e',
  '/nfe/lista': 'NF-e — Transmissão e Consulta',
  '/nfe/devolucao': 'NF-e — Devolução de Compras',
  '/nfe/nota-credito': 'NF-e — Nota de Crédito',
  '/nfe/nota-debito': 'NF-e — Nota de Débito',
  '/nfe/aceite-debito': 'NF-e — Aceite de Débito',
  '/cte/emitir': 'Emitir CT-e OS',
  '/cte/lista': 'CT-e OS — Transmissão e Consulta',
  '/cte/consultar': 'CT-e OS — Transmissão e Consulta',
  '/documents': 'Documentos',
  '/nfse/emitir':         'Emitir NFS-e Nacional',
  '/nfse/locacao':        'NFS-e Locação de Bens Móveis',
  '/nfse/lista':          'NFS-e Nacional — Transmissão e Consulta',
  '/nfse/servicos':       'NFS-e — Serviços',
  '/nfse/tributacao-municipal': 'NFS-e — Tributação Municipal por Cidade',
  '/nfse-infisc/emitir':  'Emitir NFS-e INFISC',
  '/nfse-infisc/lista':   'NFS-e INFISC — Transmissão e Consulta',
  '/relatorios/nfe-saida': 'Relatório de Notas Fiscais de Saída',
  '/relatorios/faturamento': 'Relatório do Faturamento',
  '/relatorios/issqn': 'Relatório de ISSQN',
  '/relatorios/faturamento-cliente': 'Faturamento por Cliente',
  '/relatorios/evolucao-faturamento': 'Evolução do Faturamento',
  '/relatorios/contas-receber': 'Conferência Faturamento',
  '/configuracoes': 'Parâmetros',
  '/configuracoes/clientes': 'Clientes e Fornecedores',
  '/configuracoes/naturezas': 'Naturezas da Operação',
  '/configuracoes/reforma-tributaria': 'Reforma Tributária — IBS/CBS/IS',
  '/configuracoes/tributacoes': 'Tributações',
  '/sistema/log': 'Log de Auditoria',
  '/administracao/parametros': 'Parâmetros',
  '/administracao/usuarios': 'Cadastro de Usuários',
  '/funcionarios': 'Funcionários',
  '/funcionarios/cadastro': 'Cadastro de Funcionários',
  '/funcionarios/consulta': 'Consulta de Funcionários',
  '/funcionarios/importar-despesas': 'Importar Despesas',
  '/funcionarios/planos-saude': 'Cadastro de Plano de Saúde',
  '/funcionarios/certificados-registros': 'Certificados e Registros',
  '/funcionarios/ficha-ponto': 'Ficha Ponto',
  '/funcionarios/configuracoes/parametros-ficha-ponto': 'Parâmetros de Ficha Ponto',
  '/funcionarios/configuracoes/tipos-jornada': 'Tipos de Jornada',
  '/funcionarios/configuracoes/colaboradores': 'Cadastro de Colaboradores',
  '/funcionarios/configuracoes/categorias-cnh': 'Categorias de CNH',
  '/funcionarios/configuracoes/ocorrencias': 'Ocorrências',
  '/funcionarios/configuracoes/afastamentos': 'Afastamentos de Funcionários',
  '/funcionarios/configuracoes/locais-escala': 'Local de Escalas',
  '/funcionarios/configuracoes/categorias-profissionais': 'Categorias Profissionais',
  '/funcionarios/relatorios/funcionarios': 'Relatório de Funcionários',
  '/funcionarios/relatorios/afastados': 'Funcionários Afastados',
  '/funcionarios/relatorios/salarios-atuais': 'Salários Atuais',
  '/funcionarios/relatorios/gerador': 'Gerador de Relatórios',
  '/funcionarios/relatorios/custos-plano-saude': 'Custos com Plano de Saúde',
  '/funcionarios/relatorios/aniversariantes': 'Aniversariantes e Tempo de Casa',
  '/funcionarios/documentos': 'Documentos e Validades',
  '/funcionarios/documentos/painel-vencimentos': 'Painel de Vencimentos',
  '/funcionarios/documentos/validade-exames': 'Validade dos Exames Médicos',
  '/funcionarios/documentos/controle-ferias': 'Controle de Férias',
  '/funcionarios/documentos/calendario-ferias': 'Calendário de Férias',
  '/funcionarios/documentos/vencimento-cnh': 'Vencimentos da CNH',
  '/funcionarios/documentos/vencimento-certificados': 'Vencimentos de Registros e Certificados',
  '/funcionarios/ocorrencias': 'Ocorrências e Advertências',
  '/funcionarios/ocorrencias/lancamento': 'Lançamento de Ocorrências',
  '/funcionarios/ocorrencias/consulta': 'Consultar Ocorrências',
  '/funcionarios/ocorrencias/excluir': 'Excluir Ocorrências',
  '/combustiveis': 'Combustíveis',
  '/combustiveis/lancamento-depositos': 'Lançamento Depósitos',
  '/combustiveis/lancamento-arla-deposito': 'Lançamento ARLA Depósito',
  '/combustiveis/lancamentos-externos': 'Lançamentos Externos',
  '/combustiveis/lancamento-arla-externo': 'Lançamento ARLA Externo',
  '/combustiveis/atualizacoes/lancamentos-veiculo': 'Atualizar Lançamentos',
  '/combustiveis/atualizacoes/lancamentos-arla': 'Atualizar Lançamentos ARLA',
  '/combustiveis/saldos': 'Saldo dos Tanques',
  '/combustiveis/atualizacoes/cta-plus': 'Integração CTA Plus',
  '/combustiveis/atualizacoes/corrige-importacao': 'Corrige Lançamentos por Importação',
  '/combustiveis/relatorios/consumo-arla': 'Consumo ARLA x Combustível',
  '/combustiveis/relatorios/consumo-frota': 'Consumo Mensal Frota',
  '/combustiveis/relatorios/media-combustivel': 'Média de Combustível',
  '/combustiveis/relatorios/lancamentos-dia': 'Lançamentos Dia a Dia',
  '/combustiveis/relatorios/consumo-mensal': 'Consumo Mensal por Veículo',
  '/combustiveis/relatorios/consumo-posto': 'Lançamentos por Posto',
  '/combustiveis/relatorios/abastecedor': 'Abastecimento Interno por Abastecedor',
  '/combustiveis/relatorios/desvio-consumo': 'Desvio de Consumo',
  '/combustiveis/parametros/combustiveis': 'Combustíveis',
  '/combustiveis/parametros/postos': 'Postos de Abastecimento',
  '/combustiveis/parametros/layout-postos': 'Layout Postos',
  '/combustiveis/parametros/motivos-divergencia': 'Motivos de Divergência de Média',
  '/combustiveis/saldos/encerrantes': 'Encerrantes das Bombas',
  '/combustiveis/importacoes/excel': 'Importação Excel',
  '/compras': 'Compras',
  '/compras/manifestacao/nfe': 'Manifestador do Destinatário',
  '/compras/manifestacao/cte': 'Manifestador de CT-e',
  '/compras/manifestacao/nfse': 'Manifestador de NFS-e',
  '/compras/ajustes-fiscais/estorno-nota': 'Estorno de Nota Fiscal',
  '/compras/ajustes-fiscais/alterar-data': 'Alterar Data Emissão/Recebimento',
  '/compras/ajustes-fiscais/alterar-cfop': 'Alterar CFOP das Notas Fiscais',
  '/compras/ajustes-fiscais/alterar-aplicacao': 'Altera Aplicação das Notas Fiscais',
  '/compras/utilitarios/codigos-barras': 'Emissão de Códigos de Barras',
  '/compras/utilitarios/gravar-xml-nfe': 'Gravar Arquivos XML - NF-e',
  '/compras/relatorios/notas-recebimento-emissao': 'Notas Fiscais P/data Recebimento / Emissão',
  '/compras/relatorios/notas-imposto-retido': 'Notas Fiscais C/Retenção de Impostos',
  '/compras/relatorios/notas-entrada': 'Relação de Notas de Entrada',
  '/compras/relatorios/itens-devolvidos': 'Itens Devolvidos / Rejeitados',
  '/compras/recebimentos/lancamento-notas': 'Lançamento Notas',
  '/compras/recebimentos/lancamento-nfse99': 'Lançamento NFS-e 99',
  '/compras/recebimentos/importar-nfe': 'Importar NF-e',
  '/compras/recebimentos/importar-cte': 'Importar CT-e',
  '/compras/devolucao': 'Devolução de Compras',
  '/compras/consultas/notas': 'Consulta de Notas',
  '/compras/consultas/itens': 'Consulta de Itens',
  '/compras/solicitacao': 'Solicitação de Compra',
  '/compras/solicitacao/consulta': 'Consultar Solicitações de Compra',
  '/compras/ordem-compra': 'Ordem de Compra',
  '/compras/ordem-compra/consulta': 'Consultar Ordens de Compra',
  '/compras/ordem-compra/aprovacao': 'Ordens de Compra — Aprovação',
  '/compras/parametros/condicao-pagamento': 'Condição de Pagamento',
  '/compras/parametros/compradores': 'Compradores',
  '/compras/parametros/clientes': 'Clientes e Fornecedores',
  '/compras/parametros/operacoes-comerciais': 'Operações Comerciais',
  '/compras/parametros/nao-conformidades': 'Cadastro de Não Conformidades',
}

// Nome da tela correspondente no ERP legado (GeneXus), pra facilitar a referência cruzada.
const pageCodigos: Record<string, string> = {
  '/compras/parametros/condicao-pagamento': 'TCOMCON',
  '/compras/manifestacao/nfe': 'WManDes',
  '/compras/manifestacao/cte': 'WCTEMAN',
  '/administracao/parametros': 'TSILVER',
  '/administracao/usuarios': 'TSIL004',
  '/compras/recebimentos/lancamento-notas': 'TNOTFIS',
  '/compras/recebimentos/lancamento-nfse99': 'TNOTFIS',
  '/compras/recebimentos/importar-nfe': 'WIMPNFC',
  '/compras/recebimentos/importar-cte': 'WIMPCTE',
  '/compras/consultas/notas': 'WCCO011B',
  '/compras/consultas/itens': 'WCCO011E',
  '/compras/parametros/compradores': 'COMCPR',
  '/combustiveis/parametros/combustiveis': 'TCOMBUS',
  '/combustiveis/parametros/postos': 'TPRACAS',
  '/combustiveis/parametros/layout-postos': 'TLAYPOS',
  '/combustiveis/importacoes/excel': 'WDPS082',
  '/cte/lista': 'WSELNFE',
  '/cte/consultar': 'WSELNFE',
  '/compras/solicitacao/consulta': 'WCCO528a',
  '/compras/parametros/operacoes-comerciais': 'TOPECAD',
  '/compras/parametros/nao-conformidades': 'TCADNCO',
}

// ─── Menu lateral ─────────────────────────────────────────────────────────────
// O menu é uma CONFIG, não JSX espalhado. Os ícones de linha e o desenho das
// pílulas vêm do FrotaTrack; a REGRA DE VISIBILIDADE, não.
//
// Aqui o menu mostra só o módulo em que você está: entra-se num módulo pela
// Principal (que é o lançador), e a lateral passa a listar as telas dele.
// Decisão da equipe (2026-08-18), depois de eu ter aberto tudo de uma vez.
//
// Consequência conhecida e aceita: não se troca de módulo pela lateral — volta-se
// à Principal e entra-se no outro. Na Principal, portanto, o menu tem só ela.
//
// Duas coisas diferentes filtram o menu, e não devem ser confundidas:
//   `escopo`  → ONDE você está (esta regra)
//   permissão → `acessoLimitado` (tiplib 6) e `apenasVendas` (tiplib 5)

type Leaf  = { kind: 'leaf'; to: string; label: string; icon: LucideIcon; end?: boolean }
type Group = {
  kind: 'group'; label: string; icon: LucideIcon; prefix: string; children: NavEntry[]
  /* Prefixos que fazem este módulo aparecer. Só vale no nível de cima. */
  escopo?: string[]
  /* Subcaminhos do prefixo que pertencem a outro grupo (não abrem/marcam este). */
  exceto?: string[]
}
type NavEntry = Leaf | Group

const leaf  = (to: string, label: string, icon: LucideIcon, end = false): Leaf =>
  ({ kind: 'leaf', to, label, icon, end })
const group = (label: string, icon: LucideIcon, prefix: string, children: NavEntry[], escopo?: string[], exceto?: string[]): Group =>
  ({ kind: 'group', label, icon, prefix, children, escopo, exceto })

/* O bloco fiscal aparece inteiro quando você está em qualquer uma de suas telas —
   CT-e, NF-e, NFS-e, relatórios e configurações são um módulo só ("Vendas" na
   Principal), então navegam entre si. */
const ESCOPO_FISCAL = ['/cte', '/nfe', '/nfse', '/nfse-infisc', '/relatorios', '/configuracoes']

function montarNav(acessoLimitado: boolean, apenasVendas: boolean, pathname: string, telas: Set<string> | null): NavEntry[] {
  /* Fica quem não tem escopo (a Principal) e quem tem escopo casando com a rota. */
  const nav = telas ? filtrarPorTelas(navCompleto(false, false, pathname), telas) : navCompleto(acessoLimitado, apenasVendas, pathname)
  return nav.filter(e =>
    e.kind === 'leaf' || !e.escopo || e.escopo.some(p => pathname.startsWith(p)),
  )
}

/* Com a aba Opções configurada, ela manda: some a tela sem Acesso e o grupo que ficou vazio.
   Item fora do catálogo (Principal) não é filtrado aqui. */
function filtrarPorTelas(nav: NavEntry[], telas: Set<string>): NavEntry[] {
  const catalogo = rotasCatalogo()
  return nav.flatMap((e): NavEntry[] => {
    if (e.kind === 'leaf') return !catalogo.has(e.to) || telas.has(e.to) ? [e] : []
    const children = filtrarPorTelas(e.children, telas)
    return children.length ? [{ ...e, children }] : []
  })
}

// Todas as rotas que aparecem na aba Opções
let catalogoCache: Set<string> | null = null
export function rotasCatalogo(): Set<string> {
  if (!catalogoCache) catalogoCache = new Set(catalogoTelasWeb().flatMap(g => g.telas.map(t => t.rota)))
  return catalogoCache
}

// Tela do catálogo sem Acesso marcado (só quando o usuário tem a aba Opções configurada)
export function telaBloqueada(pathname: string, telas: Set<string> | null): boolean {
  return !!telas && rotasCatalogo().has(pathname) && !telas.has(pathname)
}

// Catálogo das telas do web pra aba Opções do Cadastro de Usuários (sai do próprio menu).
export interface GrupoTelasWeb { modulo: string; grupo: string; telas: { rota: string; nome: string }[] }
const MODULO_POR_ESCOPO: Record<string, string> = {
  '/funcionarios': 'Funcionários', '/administracao': 'Administração', '/combustiveis': 'Combustíveis',
  '/compras': 'Compras', '/cte': 'Vendas',
}
export function catalogoTelasWeb(): GrupoTelasWeb[] {
  const grupos: GrupoTelasWeb[] = []
  const folhas = (g: Group) => g.children.filter((c): c is Leaf => c.kind === 'leaf').map(l => ({ rota: l.to, nome: l.label }))
  for (const e of navCompleto(false, false, '')) {
    if (e.kind === 'leaf') {
      if (e.to !== '/') grupos.push({ modulo: 'Geral', grupo: 'Geral', telas: [{ rota: e.to, nome: e.label }] })
      continue
    }
    const modulo = MODULO_POR_ESCOPO[e.escopo?.[0] ?? ''] ?? e.label
    const diretas = folhas(e)
    if (diretas.length) grupos.push({ modulo, grupo: e.label, telas: diretas })
    e.children.filter((c): c is Group => c.kind === 'group')
      .forEach(sub => grupos.push({ modulo, grupo: sub.label, telas: folhas(sub) }))
  }
  // Telas abertas pela Principal (fora do menu lateral), mas que também precisam de liberação
  const iComb = grupos.findIndex(g => g.modulo === 'Combustíveis')
  if (iComb >= 0) grupos.splice(iComb, 0, { modulo: 'Combustíveis', grupo: 'Dashboard', telas: [{ rota: '/combustiveis', nome: 'Dashboard de Abastecimento' }] })
  const iCompras = grupos.findIndex(g => g.modulo === 'Compras')
  if (iCompras >= 0) grupos.splice(iCompras, 0, { modulo: 'Compras', grupo: 'Dashboard', telas: [{ rota: '/compras', nome: 'Dashboard de Compras' }] })
  grupos.push({ modulo: 'Logs', grupo: 'Logs', telas: [{ rota: '/sistema/log', nome: 'Log de Auditoria' }] })
  return grupos
}

function navCompleto(acessoLimitado: boolean, apenasVendas: boolean, pathname: string): NavEntry[] {
  const nav: NavEntry[] = [leaf('/', 'Principal', LayoutGrid, true)]

  if (!acessoLimitado && !apenasVendas) {
    nav.push(group('Funcionários', Users, '/funcionarios', [
      leaf('/funcionarios/cadastro', 'Cadastro de Funcionários', Contact),
      leaf('/funcionarios/consulta', 'Consulta de Funcionários', Search),
      leaf('/funcionarios/planos-saude', 'Cadastro de Plano de Saúde', HeartPulse),
      leaf('/funcionarios/certificados-registros', 'Certificados e Registros', Award),
      leaf('/funcionarios/ficha-ponto', 'Ficha Ponto', Clock),
      leaf('/funcionarios/importar-despesas', 'Importar Despesas', FileSpreadsheet),
    ], ['/funcionarios'], ['/funcionarios/configuracoes', '/funcionarios/relatorios', '/funcionarios/documentos', '/funcionarios/ocorrencias']))
    nav.push(group('Relatórios e Consultas', BarChart3, '/funcionarios/relatorios', [
      leaf('/funcionarios/relatorios/funcionarios', 'Relatório de Funcionários', FileText),
      leaf('/funcionarios/relatorios/afastados', 'Funcionários Afastados', CalendarX),
      leaf('/funcionarios/relatorios/salarios-atuais', 'Salários Atuais', Wallet),
      leaf('/funcionarios/relatorios/aniversariantes', 'Aniversariantes e Tempo de Casa', Cake),
      leaf('/funcionarios/relatorios/gerador', 'Gerador de Relatórios', FileCog),
      leaf('/funcionarios/relatorios/custos-plano-saude', 'Custos com Plano de Saúde', HeartPulse),
    ], ['/funcionarios']))
    nav.push(group('Documentos e Validades', FileCheck2, '/funcionarios/documentos', [
      leaf('/funcionarios/documentos/painel-vencimentos', 'Painel de Vencimentos', BellRing),
      leaf('/funcionarios/documentos/validade-exames', 'Validade dos Exames Médicos', Stethoscope),
      leaf('/funcionarios/documentos/controle-ferias', 'Controle de Férias', Plane),
      leaf('/funcionarios/documentos/calendario-ferias', 'Calendário de Férias', CalendarDays),
      leaf('/funcionarios/documentos/vencimento-cnh', 'Vencimentos da CNH', IdCard),
      leaf('/funcionarios/documentos/vencimento-certificados', 'Vencimentos de Registros e Certificados', Award),
    ], ['/funcionarios']))
    nav.push(group('Ocorrências e Advertências', AlertTriangle, '/funcionarios/ocorrencias', [
      leaf('/funcionarios/ocorrencias/lancamento', 'Lançamento de Ocorrências', FilePlus),
      leaf('/funcionarios/ocorrencias/consulta', 'Consultar Ocorrências', Search),
      leaf('/funcionarios/ocorrencias/excluir', 'Excluir Ocorrências', Trash2),
    ], ['/funcionarios']))
    // Tabelas de Funcionários é opção à parte no menu, por último (abaixo dos relatórios)
    nav.push(group('Tabelas de Funcionários', Settings, '/funcionarios/configuracoes', [
      leaf('/funcionarios/configuracoes/parametros-ficha-ponto', 'Parâmetros de Ficha Ponto', SlidersHorizontal),
      leaf('/funcionarios/configuracoes/tipos-jornada', 'Tipos de Jornada', CalendarClock),
      leaf('/funcionarios/configuracoes/colaboradores', 'Cadastro de Colaboradores', UserCog),
      leaf('/funcionarios/configuracoes/categorias-cnh', 'Categorias de CNH', IdCard),
      leaf('/funcionarios/configuracoes/ocorrencias', 'Ocorrências', AlertTriangle),
      leaf('/funcionarios/configuracoes/afastamentos', 'Afastamentos', CalendarClock),
      leaf('/funcionarios/configuracoes/locais-escala', 'Local de Escalas', MapPin),
      leaf('/funcionarios/configuracoes/categorias-profissionais', 'Categorias Profissionais', Tags),
    ], ['/funcionarios']))

    nav.push(group('Usuários', Users, '/administracao/usuarios', [
      leaf('/administracao/usuarios', 'Cadastro de Usuários', UserCog),
    ], ['/administracao']))

    nav.push(group('Saldos', Gauge, '/combustiveis/saldos', [
      leaf('/combustiveis/saldos', 'Saldo dos Tanques', Gauge, true),
      leaf('/combustiveis/saldos/encerrantes', 'Encerrantes das Bombas', Gauge),
    ], ['/combustiveis']))

    nav.push(group('Lançamentos', Fuel, '/combustiveis/lanc', [
      leaf('/combustiveis/lancamento-depositos', 'Lançamento Depósitos', FilePlus),
      leaf('/combustiveis/lancamentos-externos', 'Lançamentos Externos', FilePlus),
      leaf('/combustiveis/lancamento-arla-externo', 'Lançamento ARLA Externo', FilePlus),
      leaf('/combustiveis/lancamento-arla-deposito', 'Lançamento ARLA Depósito', FilePlus),
    ], ['/combustiveis']))

    nav.push(group('Importações', Upload, '/combustiveis/importacoes', [
      leaf('/combustiveis/importacoes/excel', 'Importação Excel', FileInput),
    ], ['/combustiveis']))

    nav.push(group('Atualizações', RefreshCw, '/combustiveis/atualizacoes', [
      leaf('/combustiveis/atualizacoes/lancamentos-veiculo', 'Atualizar Lançamentos', Car),
      leaf('/combustiveis/atualizacoes/lancamentos-arla', 'Atualizar Lançamentos ARLA', Car),
      leaf('/combustiveis/atualizacoes/cta-plus', 'Integração CTA Plus', PlugZap),
      leaf('/combustiveis/atualizacoes/corrige-importacao', 'Corrige Lançamentos por Importação', Wrench),
    ], ['/combustiveis']))

    nav.push(group('Relatórios', BarChart3, '/combustiveis/relatorios', [
      leaf('/combustiveis/relatorios/consumo-arla', 'Consumo ARLA x Combustível', FileText),
      leaf('/combustiveis/relatorios/consumo-frota', 'Consumo Mensal Frota', FileText),
      leaf('/combustiveis/relatorios/media-combustivel', 'Média de Combustível', FileText),
      leaf('/combustiveis/relatorios/lancamentos-dia', 'Lançamentos Dia a Dia', FileText),
      leaf('/combustiveis/relatorios/consumo-mensal', 'Consumo Mensal por Veículo', FileText),
      leaf('/combustiveis/relatorios/consumo-posto', 'Lançamentos por Posto', FileText),
      leaf('/combustiveis/relatorios/abastecedor', 'Abastecimento por Abastecedor', FileText),
      leaf('/combustiveis/relatorios/desvio-consumo', 'Desvio de Consumo', FileText),
    ], ['/combustiveis']))

    nav.push(group('Parâmetros', SlidersHorizontal, '/combustiveis/parametros', [
      leaf('/combustiveis/parametros/combustiveis', 'Combustíveis', Fuel),
      leaf('/combustiveis/parametros/postos', 'Postos de Abastecimento', MapPin),
      leaf('/combustiveis/parametros/layout-postos', 'Layout Postos', FileText),
      leaf('/combustiveis/parametros/motivos-divergencia', 'Motivos de Divergência de Média', AlertTriangle),
    ], ['/combustiveis']))
  }

  if (!apenasVendas) {
    /* Compras entra com os quatro grupos soltos no topo, sem um "Compras" por
       cima: dentro do módulo esse nível a mais só afastaria as telas em um
       clique, já que a lateral inteira ali já é Compras. */
    nav.push(
      group('Manifestação e Eventos Eletrônicos', CheckCircle2, '/compras/manifestacao', [
        leaf('/compras/manifestacao/nfe', 'Manifestador de NF-e', FileInput),
        leaf('/compras/manifestacao/cte', 'Manifestador de CT-e', Truck),
        leaf('/compras/manifestacao/nfse', 'Manifestador de NFS-e', FileCheck2),
      ], ['/compras']),
      group('Recebimentos', Inbox, '/compras/recebimentos', [
        leaf('/compras/recebimentos/lancamento-notas', 'Lançamento NFE 55', FilePlus),
        leaf('/compras/recebimentos/lancamento-cte57', 'Lançamento CTe 57', Truck),
        leaf('/compras/recebimentos/lancamento-nfse99', 'Lançamento NFS-e 99', FileCheck2),
        leaf('/compras/recebimentos/importar-nfe', 'Importar NF-e', Upload),
        leaf('/compras/recebimentos/importar-cte', 'Importar CT-e', Upload),
      ], ['/compras']),
      group('Devolução de Compras', Undo2, '/compras/devolucao', [
        leaf('/compras/devolucao', 'Devolução de Compras', Undo2, true),
      ], ['/compras']),
      group('Consultas', Search, '/compras/consultas', [
        leaf('/compras/consultas/notas', 'Consulta de Notas', FileText),
        leaf('/compras/consultas/itens', 'Consulta de Itens', List),
      ], ['/compras']),
      group('Solicitação de Compra', ClipboardList, '/compras/solicitacao', [
        leaf('/compras/solicitacao', 'Nova Solicitação', FilePlus, true),
        leaf('/compras/solicitacao/consulta', 'Consultar Solicitações', Search),
      ], ['/compras']),
      group('Ordem de Compra', Receipt, '/compras/ordem-compra', [
        leaf('/compras/ordem-compra', 'Nova Ordem', FilePlus, true),
        leaf('/compras/ordem-compra/consulta', 'Consultar Ordens', Search),
        leaf('/compras/ordem-compra/aprovacao', 'OC Aguardando Aprovação', ShieldCheck),
      ], ['/compras']),
      group('Correções, Exclusões e Ajustes Fiscais', Wrench, '/compras/ajustes-fiscais', [
        leaf('/compras/ajustes-fiscais/estorno-nota', 'Estorno de Nota Fiscal', Undo2),
        leaf('/compras/ajustes-fiscais/alterar-data', 'Alterar Data Emissão/Recebimento', CalendarClock),
        leaf('/compras/ajustes-fiscais/alterar-cfop', 'Alterar CFOP das Notas Fiscais', FileCog),
        leaf('/compras/ajustes-fiscais/alterar-aplicacao', 'Altera Aplicação das Notas Fiscais', Tags),
      ], ['/compras']),
      group('Relatórios', BarChart3, '/compras/relatorios', [
        leaf('/compras/relatorios/notas-recebimento-emissao', 'Notas Fiscais P/data Receb. / Emissão', FileText),
        leaf('/compras/relatorios/notas-imposto-retido', 'Notas Fiscais C/Retenção de Impostos', Percent),
        leaf('/compras/relatorios/notas-entrada', 'Relação de Notas de Entrada', FileText),
        leaf('/compras/relatorios/itens-devolvidos', 'Itens Devolvidos / Rejeitados', Undo2),
      ], ['/compras']),
      group('Parâmetros de Compras', SlidersHorizontal, '/compras/parametros', [
        leaf('/compras/parametros/condicao-pagamento', 'Condição de Pagamento', CreditCard),
        leaf('/compras/parametros/clientes', 'Clientes e Fornecedores', Building2),
        leaf('/compras/parametros/compradores', 'Compradores', Users),
        leaf('/compras/parametros/operacoes-comerciais', 'Operações Comerciais', Handshake),
        leaf('/compras/parametros/nao-conformidades', 'Não Conformidades', AlertTriangle),
      ], ['/compras']),
      group('Utilitários', ClipboardList, '/compras/utilitarios', [
        leaf('/compras/utilitarios/codigos-barras', 'Emissão de Códigos de Barras', FileCog),
        leaf('/compras/utilitarios/gravar-xml-nfe', 'Gravar Arquivos XML - NF-e', FileInput),
      ], ['/compras']),
    )
  }

  nav.push(
    group('CT-e OS', Truck, '/cte', [
      leaf('/cte/emitir', 'Emitir', FilePlus),
      leaf('/cte/lista', 'Lista / Transmissão', List),
    ], ESCOPO_FISCAL),
    group('NF-e', FileText, '/nfe', [
      leaf('/nfe/emitir', 'Emitir', FilePlus),
      leaf('/nfe/devolucao', 'Devolução', Undo2),
      leaf('/nfe/nota-credito', 'Nota de Crédito', PlusCircle),
      leaf('/nfe/nota-debito', 'Nota de Débito', MinusCircle),
      leaf('/nfe/aceite-debito', 'Aceite de Débito', CheckCircle2),
      leaf('/nfe/lista', 'Lista / Transmissão', List),
    ], ESCOPO_FISCAL),
    group('NFS-e Nacional', FileCheck2, '/nfse', [
      leaf('/nfse/emitir', 'Emitir', FilePlus),
      leaf('/nfse/locacao', 'Emitir NFSe Locação Bens Móveis', Truck),
      leaf('/nfse/lista', 'Lista / Transmissão', List),
      leaf('/nfse/servicos', 'Serviços', Wrench),
      leaf('/nfse/tributacao-municipal', 'Tributação Municipal', MapPin),
    ], ESCOPO_FISCAL),
    group('NFS-e INFISC', FileCog, '/nfse-infisc', [
      leaf('/nfse-infisc/emitir', 'Emitir', FilePlus),
      leaf('/nfse-infisc/lista', 'Lista / Transmissão', List),
    ], ESCOPO_FISCAL),
    group('Relatórios', BarChart3, '/relatorios', [
      leaf('/relatorios/nfe-saida', 'Notas Fiscais de Saída', FileText),
      leaf('/relatorios/faturamento', 'Faturamento', BarChart2),
      leaf('/relatorios/issqn', 'ISSQN', Percent),
      leaf('/relatorios/faturamento-cliente', 'Faturamento por Cliente', Building2),
      leaf('/relatorios/evolucao-faturamento', 'Evolução do Faturamento', TrendingUp),
      leaf('/relatorios/contas-receber', 'Conferência Faturamento', Coins),
      leaf('/relatorios/download-lote', 'Download XML/PDF em Lote', Download),
    ], ESCOPO_FISCAL),
    group('Configurações', Settings, '/configuracoes', [
      leaf('/configuracoes', 'Parâmetros', SlidersHorizontal, true),
      leaf('/configuracoes/clientes', 'Clientes e Fornecedores', Building2),
      leaf('/configuracoes/naturezas', 'Naturezas da Operação', Tags),
      leaf('/configuracoes/reforma-tributaria', 'Reforma Tributária', Landmark),
      leaf('/configuracoes/tributacoes', 'Tributações', Percent),
    ], ESCOPO_FISCAL),
  )

  // Log de Auditoria só aparece no menu quando aberto pelo ícone "Logs" da tela principal
  if (!acessoLimitado && pathname.startsWith('/sistema/log')) nav.push(leaf('/sistema/log', 'Log de Auditoria', History))

  return nav
}

/* Item folha. Todo item tem ícone, inclusive dentro de submenu — no FrotaTrack
   é assim, e é o que faz o submenu não virar uma lista de texto solto. */
function NavLeaf({ entry, depth }: { entry: Leaf; depth: number }) {
  const Icon = entry.icon
  const size = depth === 0 ? 18 : depth === 1 ? 15 : 13
  const navigate = useNavigate()
  return (
    <NavLink to={entry.to} end={entry.end} title={entry.label}
      onClick={e => { if (saidaBloqueada(() => navigate(entry.to))) e.preventDefault() }}>
      <span className="nav-icon"><Icon size={size} /></span>
      <span className="nav-label">{entry.label}</span>
    </NavLink>
  )
}

function NavGroup({ entry, depth, collapsed, onExpand }: {
  entry: Group; depth: number; collapsed?: boolean; onExpand?: () => void
}) {
  const location = useLocation()
  const isActive = location.pathname.startsWith(entry.prefix) && !entry.exceto?.some(p => location.pathname.startsWith(p))
  const [open, setOpen] = useState(isActive)
  const Icon = entry.icon

  // Entrar numa rota do grupo (pela Principal, por link ou pelo endereço) abre
  // o grupo — senão o item ativo fica escondido dentro de um grupo fechado.
  useEffect(() => {
    if (isActive) setOpen(true)
  }, [isActive])

  function handleClick() {
    if (collapsed) {
      onExpand?.()
      setOpen(true)
    } else {
      setOpen(o => !o)
    }
  }

  return (
    <div className="nav-group">
      <button
        className={`nav-group-btn${isActive ? ' nav-group-btn--active' : ''}`}
        onClick={handleClick}
        title={entry.label}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', minWidth: 0 }}>
          <span className="nav-icon"><Icon size={depth === 0 ? 18 : 15} /></span>
          <span className="nav-label">{entry.label}</span>
        </span>
        {/* Chevron gira em vez de trocar de glifo — é como o FrotaTrack faz. */}
        <span className="nav-chevron" style={{ transform: open ? 'rotate(180deg)' : 'none' }}>
          <ChevronDown size={depth === 0 ? 14 : 11} />
        </span>
      </button>
      {open && !collapsed && (
        <div className="nav-group-items">
          {entry.children.map(child => (
            <NavEntryNode key={child.kind === 'leaf' ? child.to : child.prefix}
              entry={child} depth={depth + 1} collapsed={collapsed} onExpand={onExpand} />
          ))}
        </div>
      )}
    </div>
  )
}

function NavEntryNode({ entry, depth, collapsed, onExpand }: {
  entry: NavEntry; depth: number; collapsed?: boolean; onExpand?: () => void
}) {
  return entry.kind === 'leaf'
    ? <NavLeaf entry={entry} depth={depth} />
    : <NavGroup entry={entry} depth={depth} collapsed={collapsed} onExpand={onExpand} />
}

export default function Layout({ user, onLogout, acessoLimitado, apenasVendas, telasPermitidas, children }: Props) {
  const location = useLocation()
  const title = pageTitles[location.pathname] ?? 'FrotaWeb'
  const codigoTela = pageCodigos[location.pathname]
  const [collapsed, setCollapsed] = useState(false)
  const { empresas, empresaCod, empresaAtual, setEmpresaCod } = useEmpresa()
  const [empresaAberta, setEmpresaAberta] = useState(false)

  // Depende de permissão E da rota: o menu lista o módulo em que se está.
  const nav = useMemo(
    () => montarNav(acessoLimitado, apenasVendas, location.pathname, telasPermitidas),
    [acessoLimitado, apenasVendas, location.pathname, telasPermitidas],
  )

  return (
    <div className="layout">
      <aside className={`sidebar${collapsed ? ' collapsed' : ''}`}>
        {/* Aberta, o botão de recolher fica dentro da faixa do logo; recolhida, o
            CSS o solta como círculo laranja na borda — igual ao FrotaTrack. */}
        <div className="sidebar-logo">
          {!collapsed && <LogoFrotaWeb height={40} />}
          <button
            className="sidebar-collapse-btn"
            onClick={() => setCollapsed(c => !c)}
            title={collapsed ? 'Expandir menu' : 'Ocultar menu'}
          >
            {collapsed ? <ChevronRight size={12} /> : <ChevronLeft size={20} />}
          </button>
        </div>

        <nav className="sidebar-nav scrollbar-thin">
          {nav.map(entry => (
            <NavEntryNode
              key={entry.kind === 'leaf' ? entry.to : entry.prefix}
              entry={entry}
              depth={0}
              collapsed={collapsed}
              onExpand={() => setCollapsed(false)}
            />
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <span className="sidebar-avatar">{(user || '?').charAt(0).toUpperCase()}</span>
            {!collapsed && <span className="sidebar-user-name">{user}</span>}
          </div>
          <button className="logout-btn" onClick={() => { if (!saidaBloqueada(onLogout)) onLogout() }} title="Sair">
            <LogOut size={16} />
          </button>
        </div>
      </aside>

      <div className="main-content">
        <header className="topbar">
          <span className="topbar-title">{title}</span>
          {codigoTela && (
            <span style={{ marginLeft: '0.6rem', fontSize: '0.78rem', fontWeight: 700, color: '#111827' }}>
              {codigoTela}
            </span>
          )}

          <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ position: 'relative' }}>
            {/* Pílula no formato do seletor de cliente do FrotaTrack: canto 0.75rem,
                borda na cor da marca, ícone à esquerda e chevron à direita. */}
            <button
              onClick={() => setEmpresaAberta(o => !o)}
              title="Clique para trocar a empresa"
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                background: '#eff6ff', color: '#1a6ea8', border: '1px solid #1a6ea8',
                borderRadius: 12, padding: '6px 12px', fontSize: '0.8rem',
                fontWeight: 600, cursor: 'pointer', marginRight: '0.5rem',
                fontFamily: 'inherit',
              }}
            >
              <Building2 size={15} />
              Empresa: {empresaAtual ? `${empresaAtual.empcod} - ${empresaAtual.empfan || empresaAtual.empnom}` : '—'}
              <ChevronDown size={13} />
            </button>
            {empresaAberta && (
              <>
                <div onClick={() => setEmpresaAberta(false)} style={{ position: 'fixed', inset: 0, zIndex: 99 }} />
                <div style={{
                  position: 'absolute', top: '100%', left: 0, marginTop: 6,
                  zIndex: 100, background: '#fff', border: '1px solid #e5e7eb',
                  borderRadius: 16, boxShadow: '0 20px 25px -5px rgba(0,0,0,0.15)',
                  minWidth: 240, maxHeight: 320, overflowY: 'auto', padding: '4px 0',
                  overflowX: 'hidden',
                }}>
                  {empresas.map(emp => (
                    <button
                      key={emp.empcod}
                      onClick={() => { setEmpresaCod(emp.empcod); setEmpresaAberta(false) }}
                      style={{
                        display: 'block', width: '100%', textAlign: 'left', padding: '7px 12px',
                        fontSize: '0.8rem', color: emp.empcod === empresaCod ? '#1d4ed8' : '#1f2937',
                        fontWeight: emp.empcod === empresaCod ? 700 : 400,
                        background: emp.empcod === empresaCod ? '#eff6ff' : 'none',
                        border: 'none', cursor: 'pointer', whiteSpace: 'nowrap',
                      }}
                      onMouseEnter={e => (e.currentTarget.style.background = '#f3f4f6')}
                      onMouseLeave={e => (e.currentTarget.style.background = emp.empcod === empresaCod ? '#eff6ff' : '')}
                    >
                      {emp.empcod} - {emp.empfan || emp.empnom}
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>
          <span title="Versão do FrotaWeb (data e hora do último commit)" style={{ fontSize: '0.72rem', color: '#94a3b8', fontWeight: 600, whiteSpace: 'nowrap' }}>
            Versão {__APP_VERSION__}
          </span>
          </div>
        </header>
        <main className="page-content">
          {telaBloqueada(location.pathname, telasPermitidas) ? (
            <div className="card" style={{ maxWidth: 560, margin: '2rem auto', textAlign: 'center', padding: '2rem 1.5rem' }}>
              <AlertTriangle size={32} color="#d97706" style={{ marginBottom: 8 }} />
              <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1b3f7b', marginBottom: 6 }}>Sem acesso a esta tela</h3>
              <p style={{ fontSize: '0.88rem', color: '#64748b' }}>
                Seu usuário não tem permissão para "{title}". Peça a liberação no Cadastro de Usuários (aba Opções).
              </p>
            </div>
          ) : children}
        </main>
      </div>
    </div>
  )
}
